
const Dijagnoza = function(DS) {
    return DS.defineResource({
        name: 'Dijagnoza',
        endpoint: '/dijagnoze'
    });
};

Dijagnoza.$inject = ['DS'];


export {Dijagnoza};



// WEBPACK FOOTER //
// ./app/models/dijagnoza.js